// Roadmap item D: the asset owner's declared consequence (serves / breaksIfStopped / notifyFirst).
// Each answer arrives as { text, declaredInVersion, declaredAt, declaredBy } — the version, date
// and author where THAT answer's current text was first written, not the latest playbook save.
// Behavior 360 and the entry-path panel both render provenance through this one formatter so the
// two surfaces can never show the same answer with different dates (local date, via dateTime.js).
import { formatUtcDate } from "./dateTime";

const DATE_OPTIONS = { year: "numeric", month: "short", day: "numeric" };

/** The answer's verbatim text, or null when the question was not answered. */
export function declaredAnswerText(answer) {
  return answer && typeof answer.text === "string" && answer.text.trim() !== "" ? answer.text : null;
}

/** "Written in playbook v3 on Feb 14, 2026 by Dana Owner" — '' when there is no answer. The
 *  author clause is omitted when no author was recorded; the date clause when it is unparseable. */
export function declaredAnswerProvenance(answer) {
  if (declaredAnswerText(answer) == null) return "";
  const when = formatUtcDate(answer.declaredAt, DATE_OPTIONS);
  const by = typeof answer.declaredBy === "string" && answer.declaredBy.trim() !== "" ? answer.declaredBy : null;
  return `Written in playbook v${answer.declaredInVersion}${when ? ` on ${when}` : ""}${by ? ` by ${by}` : ""}`;
}
